import React, { useCallback, useState, useContext } from "react";
import { NavLink } from "react-router-dom";

import StudentsList from "../components/student/StudentsList";
import StudentItem from "../components/student/StudentItem";
import ErrorModal from "shared/components/UIElements/ErrorModal";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "shared/hooks/http-hook";
import { StoreContext } from "shared/context/store-context";
import { AuthContext } from "shared/context/auth-context";
import "./Admin.css";

const Students = (props) => {
  const store = useContext(StoreContext);
  const auth = useContext(AuthContext);
  const { isLoading, error, clearError } = useHttpClient();
  const [selectedItemId, setSelectedItemId] = useState();
  const [selectedItemShow, setSelectedItemShow] = useState(false);

  let pageItems = [];

  if (props?.students) {
    pageItems = props.students;
  } else {
    pageItems = store.students;
  }
  const newItemLink = "/new/student";
  let ItemTypeTR = "Kullanıcı Konumu";

  if (auth.schoolType === "1") {
    ItemTypeTR = "Öğrenci";
  }

  const ItemSelectHandler = useCallback((itemid) => {
    setSelectedItemShow(true);
    setSelectedItemId(itemid);
  }, []);

  const ItemUpdateHandler = useCallback((itemid) => {
    setSelectedItemId(itemid);
  }, []);

  if (isLoading || !store.storeReady) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />

      <div className="adminNavigationHeader">
        <NavLink to={newItemLink} end>
          Yeni {ItemTypeTR}
        </NavLink>
      </div>
      <div className="adminpageContainer">
        {!isLoading && pageItems && (
          <div className="adminListContainer">
            <StudentsList items={pageItems} onItemSelect={ItemSelectHandler} />
          </div>
        )}
        {selectedItemId && selectedItemShow && (
          <div className="adminUpdateContainer">
            <StudentItem
              itemid={selectedItemId}
              onItemUpdate={ItemUpdateHandler}
              onClose={() => setSelectedItemShow(false)}
            ></StudentItem>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default Students;
